import listService              from 'ListService.js';
import { ConnectionArrowClass } from 'shapelib/ConnectionArrowClass.js';
import connectionController     from 'ConnectionController.js';
import constants                from 'Constants.js';
import util                     from 'util/Util.js';
import eventBus                 from 'EventBus.js';
import objectBehaviorMap        from 'ObjectBehaviorMapService.js';
import BehaviorInstanceModel    from 'BehaviorInstanceModel.js';
import sequenceService          from 'SequenceService.js';
import Spinner                  from 'spin/spin';
import leftPanelState           from "LeftPanelStateService";
import _                        from "lodash";

class BehaviorHelperService {

    showBehaviorInstance(id, resizeWidth = 0, resizeHeight = 0 , onload = false) {
            // clear all
        this.clearCurrentInstanceView();
        let  width, height;
        // look up objects and render
        listService._currentBehaviorInstanceId = id;
        const instance = listService.getBehaviorInstance(id);
            width = resizeWidth === 0 ? instance.get('width') : resizeWidth;
            height = resizeHeight === 0 ? instance.get('height') : resizeHeight;

        eventBus.trigger('resizeBehaviorCanvas', constants.CANVAS_RAW_ID, width, height );
        $('#factories').removeClass('disabledSection');

        const spinner = new Spinner().spin($(constants.CONTENT_ID).get(0));
        window.setTimeout(() => {
            this.renderBehaviorInstance( id );
            const behaviorInstance = listService.getBehaviorInstance(id);
            this.selectAndExpandCurrentPageBehaviorSection( behaviorInstance );

            window.setTimeout(() => {
                spinner.stop();
            }, 0);
        }, 0);
    }


    showBehaviorInstanceForFilter(id,selectedCommand) {
        
        const spinner = new Spinner().spin($(constants.CONTENT_ID).get(0));
        window.setTimeout(() => {
            // clear all
            this.clearCurrentInstanceView();

            listService._currentBehaviorInstanceId = id;
            $('#factories').removeClass('disabledSection');

            this.renderBehaviorInstance( id );
            const behaviorInstance = listService.getBehaviorInstance(id);
            //PF-6221 - Forms/Reports - Changes are lost after save
            //Remove parsed Item so this instance can be processed on save
            if (typeof behaviorInstance !== 'undefined'){
                listService.unsetPageOriginalItems(behaviorInstance.get('pageId'));
                if (typeof behaviorInstance.get('parsedItem') !== 'undefined'){
                    behaviorInstance.unset('parsedItem');
                }
            }

            this.selectAndExpandCurrentPageBehaviorSection( behaviorInstance );
            window.setTimeout(() => {
                spinner.stop();
                const selectedObject = listService.getCanvasObjectById(selectedCommand);
                if (selectedObject) {
                    selectedObject.hasBorders = true;
                    listService.fcanvas.setActiveObject(selectedObject).renderAll();
                    selectedObject.model.set('active', true, constants.MODEL_SILENT);
                    eventBus.trigger('selectSingleItemFromCanvas');
                }
            }, 200);
        }, 150);
    }

    //====================================================================================
    // PuBLIC
    // Two passes:
    // 1. Enum all objects in the given behavior instance (aka PF "Event"):
    //      Render each.
    //
    // 2. Enum the objects again:
    //      Recreate and render any connections found. Make them "sticky" to endpoints.
    //
    // Said another way: draw the widgets, and then visually connect them.
    //====================================================================================
    renderBehaviorInstance( id ) {
        //------------------------------------------------------------------------------------
        // Note on connection line and dots data structure (hard to remember, so refer here:
        /*------------------------------------------------------------------------------------
         Connection
         end: 'A End'
         line: klass
         model: BehaviorModel
         attributes:
         widget: klass
         _objects[5]
         0: klass (the visible shape object)
         1: klass (dot 0)
         2: klass (dot 1)
         3: klass (dot 2)
         4: klass (dot 3)
         model: LineModel
         attributes:
         owners:
         dest: PF_11
         src: PF_12
         ----------------------------------------------------------------------------*/


        function connect( fcanvas, processedConnectionIds ){
            const c = 2 * constants.CONNECTION_RADIUS; // .. radius of orange dot
            const
                locked = true,
                unlocked = !locked;

            // Draw connection Lines such that they associate to source-dest command connection points.
            // Restrict to getting connections for current instance ID ( matching connection.scriptId )

            const behaviorConnectionsList = listService.behaviorConnections
                .filter( connection => connection.scriptId === listService.currentBehaviorInstanceId );

            behaviorConnectionsList.forEach(  (connection, k) => {
                    // If not already processed for other endpoint:
                    if (!processedConnectionIds[k]) {
                        processedConnectionIds[k] = true;
//                        console.log(`CONNECT: construction SECOND PASS`, connection);
                        const cinfo = util.getCommandCoordInfo(connection);

                        // A fabric.js shape for rendering
                        if (cinfo.coords[0] === cinfo.coords[2]){
                            ++cinfo.coords[2];
                        }
                        if (cinfo.coords[1] === cinfo.coords[3]){
                            ++cinfo.coords[3];
                        }

                        let posCop = $('#aPageSel').offset(),
                        wX = $('#aForm').scrollLeft(), wY = $('#aForm').scrollTop(),
                        wH = $('#aForm').height(), wW = $('#aForm').width(),
                        oH = $('#aPageSel').outerHeight(), oW = $('#aPageSel').outerWidth();

                        let visible = true;
                        if ( (cinfo.coords[0]> (wW + wX) && cinfo.coords[2]> (wW + wY)) ||
                         (cinfo.coords[1]> (wH + wX) && cinfo.coords[3]> (wH + wY)) ){
                            visible = behaviorConnectionsList>constants.MAX_BEHAVIORS_TO_DISPLAY? false: true;
                        }

                        const opts = constants.LINE_MODEL_OPTIONS;
                        opts.model = connection.model;
                        opts.visible = visible;
                        const line = new ConnectionArrowClass(cinfo.coords, opts);
                        connection.line = line;
                        connection.widgetVisible = visible;
                        connection.coords = cinfo.coords;

                        // Ensure fabric event handler can see the model for property clicks
                        //const model = new LineModel({});
                        line.model = connection.model; // = model;

                        // Hold fabric.js line in connection model, created from XML
                        fcanvas.add(line);

                        // Stick the line to fabric raw widgets to associate movement sticking
                        const
                            w1 = cinfo.src.model.get('widget'),
                            w2 = cinfo.dest.model.get('widget');

                        line.srcId = w1.model.get('id');
                        line.destId = w2.model.get('id');

                        connectionController.glueLineToEndPoints(w1, w2, line, null);
                    }

                });
        }

        const instanceCommands = listService.getBehaviorInstanceObjects( id );

        //Remove parsed Item so this instance can be processed on save
        const instance = listService.getBehaviorInstance(id);
        if (typeof instance !== 'undefined'){
            listService.unsetPageOriginalItems(instance.get('pageId'));
            if (typeof instance.get('parsedItem') !== 'undefined'){
                instance.unset('parsedItem');
            }
        }

        let partialRender = instanceCommands.size>constants.MAX_BEHAVIORS_TO_DISPLAY? true:false;
        // Pass 1. Create, store, and then draw fabric.js widgets on canvas
        let loadingBehaviors = true;
        instanceCommands.forEach( view => view.render(loadingBehaviors, partialRender));
        // Pass 2. Draw connections between stored widgets
        // Disallow dupes caused by pairs of endpoint widgets
        const processedConnectionIds = {};
        instanceCommands.forEach( () => connect( listService.fcanvas, processedConnectionIds ) );

        listService.fcanvas.deactivateAll().renderAll();
    }

    clearCurrentInstanceView( ) {
        const canvas = listService.fcanvas;
        canvas.clear();

        // TODO - Redraw Page Grid

    }

    selectAndExpandCurrentPageBehaviorSection(behaviorInstance) {
        const id = behaviorInstance.get('pageId'),
            owner = behaviorInstance.get('ownerId');
        let parent = owner==='Form' ? 'aform' : listService.getObject(owner);

        let pageId = listService.currentPageId === id ? listService.currentPageId : id;
        pageId = parent === 'aform'? 'aform' : pageId;
        // Expand Page and parent section
        $('.page-selected').removeClass('page-selected');
        $('#tn-pg-' + pageId + ' .document-heading').addClass('page-selected')
                            .addClass('expanded-page').removeClass('collapsed-page');
        $('#well' + pageId).collapse('show');
        const pageSwitch = $('#tn-pg-' + pageId + ' .document-heading a.switch i');
        pageSwitch.removeClass('pf-carot-left').addClass('pf-carot-down');
        this.expandBehaviorParent(parent);

        if(id && id !== ""){
            listService.currentPageId = id;
        }
        
        //  Select behavior on the tree
        $('li[data-objectid="' + behaviorInstance.get('ownerId')
            + '"][data-behaviorKey="'+behaviorInstance.attributes.behaviorKey+'"]').addClass('controlSelected');

        // Scroll to selected behavior
        setTimeout( () => {
            leftPanelState.restore();
        }, 450);

    }

    expandBehaviorParent(parent) {
        if (parent) {
            let parentId = parent==='aform'? 'aform': parent.model.get('id');
            // If parent belongs to a group, expand the group first
            if (parent._groupId)  {
                let grandPa = listService.getObject(parent._groupId);
                this.expandBehaviorParent(grandPa);
            }
            if (parent !=='aform') {
                $('#objects-page-group-' + parentId).collapse('show');
            } else {
                $('#well_aform').collapse('show');
            }
            $('li[data-id="'+ parentId +'"]').addClass('controlSelected');
            const behaviorSwitch = $('li[data-id="'+parentId +'"] a i').first();
            behaviorSwitch.removeClass('pf-carot-left').addClass('pf-carot-down');
            behaviorSwitch.removeClass('pf-rotate-icon').addClass('pf-no-rotate-icon');
        }
    }

    getBehaviorInfo(objectId, behaviorKey) {
        const returnObj = {
            text: '',
            owner: '',
            ownerId: objectId
        };

        if (behaviorKey === 'workflow') {
            returnObj.text = 'Workflow';
        } else {

          /*  // Passed to object filter to collect a list of table controls
            const filterTables = (control) => {
                return (
                    (control.model.attributes.factoryKey === 'control_table')
                );
            };*/

            let obj = listService.getObject(objectId) || listService.getPage(objectId);

            // Not directly in object list? Maybe its a table column -- a gridData item
            if (!obj) {
                // const tableControls = listService.getFilteredControls(filterTables);
                const tableControls = listService.objectList.filter( (c, v) => 'control_table' === c.model.get('factoryKey') );

                tableControls.map(objTable => {
                    const gd = objTable.model.get('gridData');
                    if (gd) {

                        gd.every( column => {

                           if (objectId === column.id) {
                               obj = column; //{model: column};
                               return false;
                           }
                            return true;
                        });

                    }
                });
            }

            // obj still not resolved? Default to form
            if (!obj) {
                obj = listService.currentForm;
            }

            if (obj) {
                // Careful: most objects (controls) HAVE a model, but some objects could BE a model (gridData item)
                const
                    model = obj.model ? obj.model : obj,
                    type = model.get('factoryKey'),
                    found = objectBehaviorMap.getBehaviors(type).filter(behavior => (behavior.behaviorKey === behaviorKey));

                if (found.length) {
                    returnObj.text = found[0].text;
                }

                returnObj.owner = model.get('name');

                if (type === 'layout_frame' || type === 'reports_frame') {
                    returnObj.owner = 'Form';
                    returnObj.ownerId = 'Form';
                }
            }
        }
        return returnObj;
    }

    createNewInstanceOnLoad(instanceToLoad) {
        const newId = sequenceService.nextDomId();
        const info = this.getBehaviorInfo(instanceToLoad.objectId, instanceToLoad.behaviorKey);
        const control = listService.getObject(info.ownerId);
        const pageId = control && control.model.get('pageId') ? control.model.get('pageId') : listService.currentPageId;
        const newInstance = new BehaviorInstanceModel({
            id: newId,
            behaviorKey: instanceToLoad.behaviorKey,
            text: info.text,
            open: true,
            owner: info.owner,
            ownerId: info.ownerId,
            pageId: instanceToLoad.behaviorKey === 'workflow' ? undefined : pageId
        });
        listService.addBehaviorInstance( newInstance );
        listService._currentBehaviorInstanceId = newId;

        return newInstance;
    }

    createConnections(scriptId, behaviorId){
        let connections = [];
        listService.behaviorConnections
                .filter( connection => connection.scriptId === scriptId )
                .map(  (connection, k) => {
                        const coords = [0,0,0,0];
                        const cinfo = {coords};
                        const opts = constants.LINE_MODEL_OPTIONS;
                        opts.model = connection.model;
                        const line = new ConnectionArrowClass(cinfo.coords, opts);
                        connection.line = line;

                        line.model = connection.model;
                        let conn;
                        line.srcId = connection.srcCommand.model.get('id');
                        line.destId = connection.destCommand.model.get('id');

                        if(connection.srcCommand.model.get('id') === behaviorId ){
                            conn =  {line: line, end: constants.A_END};
                        }else{
                            conn = {line: line, end: constants.B_END};
                        }
                        connections.push(conn);
                });

       return connections;
    }

    showHiddenBehaviors(){
        let posCop = $('#aPageSel').offset(),
            wX = $('#aForm').scrollLeft(), wY = $('#aForm').scrollTop(),
            wH = $('#aForm').height(), wW = $('#aForm').width(),
            oH = $('#aPageSel').outerHeight(), oW = $('#aPageSel').outerWidth();

        let scrollLeftMax = wW + wX, scrollTopMax = wH +wY,
            scrollLeftMin = wW - wX, scrollTopMìn = wH -wY;

        const spinner = new Spinner().spin($(constants.CONTENT_ID).get(0));
        window.setTimeout(() => {

            const instanceCommands = listService.getBehaviorInstanceObjects( listService.currentBehaviorInstanceId );
            let notVisibleOnes = instanceCommands.
                filter(obj => (obj.widgetVisible=== false &&
                                (obj.renderLeft<=scrollLeftMax  && obj.renderTop <=scrollTopMax) ) );
                if (notVisibleOnes.size > 0) {
                    console.log('rendering ', notVisibleOnes.size, ' objs');
                }
                notVisibleOnes.forEach( (view, k) => {
                    view.widgetVisible = true;
                    view.render(true, true);
                });

                let fcanvas = listService.fcanvas;
                const processedConnectionIds = {};
                let myConn = listService.behaviorConnections
                    .filter( connection => (connection.scriptId === listService.currentBehaviorInstanceId
                                && connection.widgetVisible === false &&
                               ((connection.coords[0]<= (wW + wX) || connection.coords[2]<= (wW + wY)) &&
                                  (connection.coords[1]<= (wH + wX) || connection.coords[3]<= (wH + wY)))));

                myConn.forEach(  (connection, k) => {
                    // If not already processed for other endpoint:
                    if (!processedConnectionIds[k]) {
                        processedConnectionIds[k] = true;
                        const cinfo = util.getCommandCoordInfo(connection);

                        // A fabric.js shape for rendering
                        if (cinfo.coords[0] === cinfo.coords[2]){
                            ++cinfo.coords[2];
                        }
                        if (cinfo.coords[1] === cinfo.coords[3]){
                            ++cinfo.coords[3];
                        }

                        let visible = true;

                        const opts = constants.LINE_MODEL_OPTIONS;
                        opts.model = connection.model;
                        opts.visible = visible;
                        const line = new ConnectionArrowClass(cinfo.coords, opts);
                        connection.line = line;
                        connection.widgetVisible = visible;

                        // Ensure fabric event handler can see the model for property clicks
                        //const model = new LineModel({});
                        line.model = connection.model; // = model;

                        // Hold fabric.js line in connection model, created from XML
                        fcanvas.add(line);

                        // Stick the line to fabric raw widgets to associate movement sticking
                        const
                            w1 = cinfo.src.model.get('widget'),
                            w2 = cinfo.dest.model.get('widget');

                        line.srcId = w1.model.get('id');
                        line.destId = w2.model.get('id');

                        connectionController.glueLineToEndPoints(w1, w2, line, null);
                    }
                });
            window.setTimeout(() => {
                spinner.stop();
                // PF-8386 Removed 'deactivateAll' to avoid losing the selection on scroll
                fcanvas.renderAll();
            }, 0);
        }, 0);
    }

    processBehaviorClickEvent(ev,factoryKey,model){
        leftPanelState.save();
        //extract behaviorKey and object ID to pass
        const
            isColumn = factoryKey && factoryKey.endsWith('Column'),
            behaviorKey = ev.currentTarget.attributes['data-behaviorkey'].value,
            id = ev.currentTarget.attributes['data-objectid'].value;
        listService.linkClicked = true;
        // id should be a column id if we click a table column.
        // if so, then ownerCol should bet set to that gridData object value
        // The view.model.attributes holds gridData[] that holds columns 0..n view values
        // Q: how to send this value to the other side of the router link?
        if (isColumn && model.get('id') !== id) {
            const
                tableId = model.get('id'),
                tableView = listService.getObject(tableId),
                column = _.find(tableView.getColumns(), c => c.id === id);

            /*
            console.log(`table id:`, tableId);
            console.log(`table:`, tableView);
            console.log(`column id:`, id);
            console.log(`column:`, column);
            */

        }
        Backbone.history.loadUrl(`behaviors/${id}/${behaviorKey}`);
        listService.clearSelected();
    }

}
export default new BehaviorHelperService;